import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

import { editDataRequestItem } from '../../../services/dealGPT';
import { DataRequestItem } from '../../../Types/dealGPT';

interface DataRequestItemNotesProps {
  item: DataRequestItem;
  onItemChanged: (newItem: DataRequestItem) => void;
}

export const DataRequestItemNotes = ({ item, onItemChanged }: DataRequestItemNotesProps) => {
  const [editingNotes, setEditingNotes] = useState(false);
  const [draftNotes, setDraftNotes] = useState(item.notes || '');

  const handleSave = useCallback(async () => {
    const newItem = await editDataRequestItem(item.projectId, {
      id: item.id,
      notes: draftNotes,
    });

    onItemChanged(newItem);
    setEditingNotes(false);
  }, [draftNotes, item.id, item.projectId, onItemChanged]);

  const handleCancel = useCallback(() => {
    setDraftNotes(item.notes || '');
    setEditingNotes(false);
  }, [item.notes]);

  useEffect(() => {
    setDraftNotes(item.notes || '');
  }, [item.id, item.notes]);

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Stack direction="row" spacing={1} justifyContent="space-between">
        <Typography variant="h6">Notes</Typography>

        {!editingNotes ? (
          <Button variant="outlined" size="small" onClick={() => setEditingNotes(true)}>
            Edit
          </Button>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              size="small"
              onClick={handleSave}
              disabled={draftNotes === item.notes}
            >
              Save
            </Button>
            <Button variant="text" size="small" onClick={handleCancel}>
              Cancel
            </Button>
          </Stack>
        )}
      </Stack>

      <TextField
        value={editingNotes ? draftNotes : item.notes || ''}
        onChange={(e) => setDraftNotes(e.target.value)}
        multiline
        rows={5}
        variant="outlined"
        placeholder="Enter your Notes..."
        aria-label="Notes"
        disabled={!editingNotes}
      />
    </Box>
  );
};
